"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDetails = void 0;
const react_1 = __importDefault(require("react"));
const index_1 = require("../index");
const styles_1 = require("./styles");
const OrderDetails = (props) => {
    const { orderPlacedCopy, emailConfirmationSentCopy, orderIdCopy, orderIdText, productDescriptionText, willBeShippedText, guaranteedDeliveryCopy, guaranteedDeliveryDateText, reviewOrEditOrderCopy, reviewOrEditOrderUrl, width } = props;
    return (react_1.default.createElement(styles_1.OrderDetailsContainer, { width: width },
        react_1.default.createElement(index_1.Text, { bold: true, fontSize: "21px", lineHeight: "1.7", color: "green" },
            "\u2714 ",
            orderPlacedCopy),
        react_1.default.createElement(styles_1.StyledDetailsContainer, null,
            react_1.default.createElement("div", null,
                react_1.default.createElement(index_1.Text, { inline: true }, emailConfirmationSentCopy)),
            react_1.default.createElement("div", null,
                react_1.default.createElement(index_1.Text, { bold: true, inline: true },
                    orderIdCopy,
                    "\u00A0:\u00A0"),
                react_1.default.createElement(index_1.Text, { inline: true }, orderIdText)),
            react_1.default.createElement("div", null,
                react_1.default.createElement(index_1.Text, null,
                    productDescriptionText,
                    "\u00A0",
                    willBeShippedText)),
            react_1.default.createElement("div", null,
                react_1.default.createElement(index_1.Text, { bold: true, inline: true },
                    guaranteedDeliveryCopy,
                    "\u00A0:\u00A0"),
                react_1.default.createElement(index_1.Text, { bold: true, inline: true, color: "green" }, guaranteedDeliveryDateText)),
            react_1.default.createElement("div", null,
                react_1.default.createElement(index_1.Link, { href: reviewOrEditOrderUrl, fontSize: "13px" }, reviewOrEditOrderCopy)))));
};
exports.OrderDetails = OrderDetails;
__exportStar(require("./types"), exports);
